import { api } from './client.js'
import { streamOperation } from './operations.js'
import { downloadFile } from './downloads.js'

export async function exportAnnotated(file) {
  const { data: op } = await api.post(`/api/files/${file.id}/redactions/export`)
  const done = await streamOperation(op.operationId)
  if (done.status !== 'DONE') throw new Error(done.result?.error || 'writing the annotated PDF failed')
  await downloadFile(file, 'annotated')
}

export async function importAnnotated(fileId, file, baseVersion) {
  const body = new FormData()
  body.append('baseVersion', baseVersion)
  body.append('file', file, file.name || 'annotated.pdf')
  let op
  try {
    ;({ data: op } = await api.post(`/api/files/${fileId}/redactions/import`, body, { headers: { 'Content-Type': 'multipart/form-data' } }))
  } catch (e) {
    if (e.response?.status === 409 && e.response.data?.code === 'STALE_VERSION') return { stale: { currentVersion: e.response.data.currentVersion } }
    throw e
  }
  const done = await streamOperation(op.operationId)
  if (done.status === 'ERROR' && done.result?.code === 'STALE_VERSION') return { stale: { currentVersion: done.result.currentVersion } }
  if (done.status !== 'DONE') throw new Error(done.result?.error || 'reading the annotated PDF failed')
  return { done: done.result }
}
